import './seal.scss';
